(function () {
  // Only run on your ONE product page (because you set window.priceRevealHandle there)
  if (window.priceRevealHandle !== 'collar-canvas') return;

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);
    } catch {
      return `${(cents / 100).toFixed(2)}`;
    }
  }

  function getSelectedVariantId() {
    const form = document.querySelector('form[action^="/cart/add"]');
    if (!form) return null;
    const idInput = form.querySelector('input[name="id"]');
    return idInput ? Number(idInput.value) : null;
  }

  async function getVariantPriceCents() {
    const variantId = getSelectedVariantId();
    if (!variantId) return null;

    // Shopify provides a product JSON endpoint on the product handle
    const res = await fetch(`/products/${window.priceRevealHandle}.js`, { credentials: 'same-origin' });
    if (!res.ok) return null;

    const product = await res.json();
    const v = (product.variants || []).find(x => Number(x.id) === variantId);
    return v ? Number(v.price) : null; // price in cents
  }

  function findAddToCartButton() {
    // Most themes: the primary ATC is the submit button inside the /cart/add form
    const form = document.querySelector('form[action^="/cart/add"]');
    if (!form) return null;
    return form.querySelector('button[type="submit"], input[type="submit"]');
  }

  async function updateButtonLabel() {
    const btn = findAddToCartButton();
    if (!btn) return;

    const cents = await getVariantPriceCents();
    if (cents == null) return;

    // Currency: use Shopify global if available, otherwise your shop currency
    const currency =
      (window.Shopify && Shopify.currency && Shopify.currency.active) ||
      (window.Shopify && Shopify.currency && Shopify.currency.iso_code) ||
      'USD';

    const price = formatMoney(cents, currency);
    const label = `Checkout | ${price}`;

    if (btn.tagName === 'INPUT') btn.value = label;
    else btn.textContent = label;
    btn.style.fontWeight = '400';
  }

  // Update on load + when variant changes
  document.addEventListener('change', updateButtonLabel);
  document.addEventListener('input', updateButtonLabel);

  // Some themes re-render DOM on variant switch
  const obs = new MutationObserver(() => updateButtonLabel());
  obs.observe(document.documentElement, { subtree: true, childList: true });

  updateButtonLabel();
})();
